"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wizard = require("../Wizard/Wizard");
var _CalculatorTemplate = require("../Wizard/CalculatorTemplate");
var _ModalChargeWizardCalc = require("./ModalChargeWizardCalc.config");
var _ModalChargePageOne = _interopRequireDefault(require("./ModalChargePageOne"));
var _ModalChargePageTwo = _interopRequireDefault(require("./ModalChargePageTwo"));
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-tabs */

var ModalChargeCalculator = props => {
  var {
    config,
    initialValuesOverride
  } = props;
  var [stepNumber, setStepNumber] = (0, _react.useState)(0);
  var [snapshot, setSnapshot] = (0, _react.useState)({});
  var [validationData, setValidationData] = (0, _react.useState)(null);
  var defaultTitle = 'What is my modal charge and annual percentage rate?';
  var currentConfig = config.Steps[stepNumber];
  var initialValues = initialValuesOverride ? initialValuesOverride : _ModalChargeWizardCalc.initialValuesConfig;

  // Refinement modal handlers here
  var [showRefineModal, setShowRefineModal] = (0, _react.useState)(false);
  var refinementHandleClose = () => {
    setShowRefineModal(false);
    setValidationData(null);
  };
  var handleShow = values => {
    (0, _utils.customTealiumEvent)(_ModalChargeWizardCalc.calcName, 'click', 'changeYourAssumptions');
    setSnapshot(values);
    setShowRefineModal(true);
    setValidationData(_ModalChargeWizardCalc.validationConfig[0]);
  };

  // Disclosure modal handler here
  var [showDisclosureModal, setShowDisclosureModal] = (0, _react.useState)(false);
  var disclosureHandleClose = () => {
    setShowDisclosureModal(false);
  };
  var disclosureHandleShow = () => {
    (0, _utils.customTealiumEvent)(_ModalChargeWizardCalc.calcName, 'click', 'disclosure');
    setShowDisclosureModal(true);
  };
  return /*#__PURE__*/_react.default.createElement(_CalculatorTemplate.CalculatorTemplate, {
    config: config,
    currentConfig: currentConfig,
    defaultTitle: defaultTitle
  }, /*#__PURE__*/_react.default.createElement(_Wizard.Wizard, {
    passthroughId: "modalCharge",
    setStepNumber: setStepNumber,
    stepNumber: stepNumber,
    initialValues: initialValues,
    currentConfig: currentConfig,
    onSubmit: null,
    validationData: validationData,
    calcName: _ModalChargeWizardCalc.calcName,
    maxSteps: 2
  }, /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _ModalChargeWizardCalc.validationConfig[0]
  }, /*#__PURE__*/_react.default.createElement(_ModalChargePageOne.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: handleShow,
    validationSchema: null,
    sideButtonOnClick: disclosureHandleShow,
    nextButtonAsTypeButton: true
  }, /*#__PURE__*/_react.default.createElement(_ModalChargePageTwo.default, {
    disclosureHandleClose: disclosureHandleClose,
    showDisclosure: showDisclosureModal,
    refinementHandleClose: refinementHandleClose,
    snapshot: snapshot,
    showRefinement: showRefineModal
  }))));
};
var _default = exports.default = ModalChargeCalculator;